import React from "react";
import "./TermsAndPrivacy.css";

const TermsAndPrivacy = () => {
  return (
    <div className="terms-container">
      <h1 className="terms-title">Términos y Condiciones</h1>
      <div className="terms-content">
        <h2>1. Introducción</h2>
        <p>
          Bienvenido/a a nuestra plataforma. Estos Términos y Condiciones
          regulan el uso de nuestro sitio web y los servicios proporcionados a
          través de nuestra plataforma. Al acceder o utilizar nuestro sitio,
          aceptas estar legalmente obligado/a por estos términos. Si no estás
          de acuerdo con alguna parte, por favor, abstente de utilizar nuestros
          servicios.
        </p>

        <h2>2. Definiciones</h2>
        <p>
          <strong>"Plataforma":</strong> El sitio web y las aplicaciones móviles
          relacionadas con nuestros servicios. <br />
          <strong>"Usuario":</strong> Cualquier persona que se registre,
          utilice o acceda a la plataforma, ya sea como solicitante o
          proveedor/a de servicios. <br />
          <strong>"Servicios":</strong> Funcionalidades ofrecidas por nuestra
          plataforma, incluidas la publicación de solicitudes de servicios,
          presupuestos, carga de currículums y búsqueda de oportunidades
          laborales.
        </p>

        <h2>3. Uso de la Plataforma</h2>
        <p>
          Como usuario, te comprometes a utilizar nuestra plataforma de manera
          ética y legal. Queda prohibido:</p>
          <ul>
            <li>Falsificar tu identidad o suplantar a otra persona.</li>
            <li>Publicar contenido que sea ilegal, ofensivo, o que infrinja los derechos de terceros.</li>
            <li>Interferir con el funcionamiento de la plataforma o intentar acceder a áreas restringidas.</li>
          </ul>
        

        <h2>4. Responsabilidades</h2>
        <p>
          Nuestra plataforma actúa como un intermediario entre solicitantes y
          proveedores/as de servicios. No garantizamos la calidad, idoneidad o
          cumplimiento de los servicios ofrecidos por los usuarios. Las
          transacciones y acuerdos realizados entre usuarios son de exclusiva
          responsabilidad de las partes involucradas.
        </p>

        <h2>5. Modificaciones</h2>
        <p>
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán notificadas a través de la
          plataforma y entrarán en vigor inmediatamente después de su
          publicación.
        </p>

        <h1 className="terms-title">Políticas de Seguridad y Protección de Datos</h1>

        <h2>1. Recopilación de Datos</h2>
        <p>
          Recopilamos datos personales proporcionados por los usuarios, como
          nombre, correo electrónico, ubicación, historial de solicitudes, y
          otra información relevante para el funcionamiento de la plataforma.
          Además, recopilamos datos no identificativos, como estadísticas de
          uso, mediante cookies y herramientas analíticas.
        </p>

        <h2>2. Uso de los Datos</h2>
        <p>
          Los datos recopilados se utilizan para:</p>
          <ul>
            <li>Proporcionar y personalizar los servicios ofrecidos en la plataforma.</li>
            <li>Facilitar la comunicación entre solicitantes y proveedores/as de servicios.</li>
            <li>Mejorar la experiencia del usuario mediante análisis y optimizaciones.</li>
          </ul>
        

        <h2>3. Protección de Datos</h2>
        <p>
          Implementamos medidas técnicas y organizativas avanzadas para proteger
          los datos personales contra accesos no autorizados, pérdida o robo.
          Entre estas medidas se incluyen:</p>
          <ul>
            <li>Cifrado de datos sensibles durante su transmisión.</li>
            <li>Control de acceso basado en roles.</li>
            <li>Auditorías regulares de nuestros sistemas y prácticas de seguridad.</li>
          </ul>
        

        <h2>4. Derechos de los Usuarios</h2>
        <p>
          Los usuarios tienen derecho a:</p>
          <ul>
            <li>Acceder, corregir o eliminar sus datos personales.</li>
            <li>Restringir u oponerse al procesamiento de sus datos.</li>
            <li>Solicitar la portabilidad de sus datos.</li>
          </ul>
        <p> Para ejercer estos derechos, puedes contactarnos a través del correo
          electrónico indicado en la plataforma.
        </p>

        <h2>5. Conservación de Datos</h2>
        <p>
          Conservaremos los datos personales solo durante el tiempo necesario
          para cumplir con los fines para los que fueron recopilados, a menos
          que la ley exija lo contrario.
        </p>

        <h2>6. Transferencias Internacionales</h2>
        <p>
          En caso de que transfiramos datos personales a terceros ubicados fuera
          del Espacio Económico Europeo (EEE), garantizamos que dichas
          transferencias cumplen con los estándares establecidos por el GDPR,
          mediante cláusulas contractuales estándar o mecanismos de certificación.
        </p>

        <h2>7. Cambios en las Políticas</h2>
        <p>
          Nos reservamos el derecho de actualizar estas políticas. Las
          modificaciones serán notificadas y publicadas en nuestra plataforma.
        </p>

        <h2>Contacto</h2>
        <p>
          Si tienes preguntas sobre estos términos o nuestras políticas, puedes
          contactarnos en <strong>support@apimys.com</strong>.
        </p>
      </div>
    </div>
  );
};

export default TermsAndPrivacy;
